<template>
  <div class="enterprise-qualification">
    <div class="title">
      <span>{{ $theme ? '企业资质' : 'ENTERPRISE QUALIFICATION' }}</span>
    </div>
    <div class="subtitle">{{
        $theme ? '跨越多领域，涵盖行业经营和技术等各方面资质，护航企业经营' : 'Spanning multiple fields, covering all aspects of industry management and technology qualifications, escort enterprise management'
      }}
    </div>
    <img src="@/assets/img/enterprise-qualification.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'enterpriseQualification',
  components: {},
  data() {
    return {}
  },
  computed: {},
  mounted() {
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
@import './Index.scss';
</style>
